import Vue from 'vue'
import App from './App.vue'
import router from "./router";
// import swiper from "./swiper.min";
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css';
import './assets/common.less'
import md5 from 'js-md5';
Vue.prototype.$md5=md5
Vue.use(ElementUI);

Vue.config.productionTip = false
import common from'./api/common'
Vue.prototype.$common = common;
// Vue.prototype.$swiper = swiper;
import 'swiper/css/swiper.css'
import store from './vuex/store';

new Vue({
  router,
  store,
  render: h => h(App),
}).$mount('#app')
